export enum UserAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    UPDATE_USER_LIST = "UPDATE_USER_LIST",
    ADD_USER_LIST = "ADD_USER_LIST",
    UPDATE_USER_SEARCH_REQ = "UPDATE_USER_SEARCH_REQ",
    SET_UPDATE_USER = "SET_UPDATE_USER",
}